export default "__VITE_ASSET__Uemmr$____"